import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function FileIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 0C11.3 0 11.5 0.1 11.7 0.3L15.7 4.3C15.9 4.5 16 4.7 16 5V15C16 15.6 15.6 16 15 16H1C0.4 16 0 15.6 0 15V1C0 0.4 0.4 0 1 0H3V3C3 3.6 3.4 4 4 4H9C9.6 4 10 3.6 10 3V0H11ZM3 13H13V10C13 9.4 12.6 9 12 9H4C3.4 9 3 9.4 3 10V13Z"
        />
        <path d="M7 0H9V3H7V0Z" />
      </svg>
    </Icon>
  );
}
